export function isAbortError(error: unknown): boolean {
  const errObj = error as { name?: string; code?: string }
  return (
    errObj?.name === 'AbortError' ||
    errObj?.name === 'CanceledError' ||
    errObj?.code === 'ERR_CANCELED'
  )
}
